import { gql } from '@apollo/client';

export default gql`
  mutation editInspection(
    $id: ID!
    $inspectionSubjectId: ID
    $name: String!
    $result: Int
    $periodCycle: String!
    $periodNumber: Int!
    $dueDate: ISO8601DateTime!
    $doneAt: ISO8601DateTime
    $notes: String
    $status: Int!
    $inspectionFields: [InspectionFieldInput!]
    $inspectorId: ID
  ) {
    editInspection(
      input: {
        id: $id
        inspectionSubjectId: $inspectionSubjectId
        name: $name
        periodCycle: $periodCycle
        periodNumber: $periodNumber
        dueDate: $dueDate
        doneAt: $doneAt
        notes: $notes
        status: $status
        result: $result
        inspectionFields: $inspectionFields
        inspectorId: $inspectorId
      }
    ) {
      inspection {
        id
        name
      }
    }
  }
`;
